import {_hasProperty} from '../common/helpers/HelperFunc';
import SuperPartnerVO from './SuperPartnerVO';

export default class SuperPartnersResultVO {

	/** @type Array */
	bullseye = [];

	/** @type Array */
	other = [];

	/** @type Array */
	arrOtherAnswers = [];

	/** @type bool */
	withoutMatch = false;

	constructor(data) {

		if (_hasProperty(data, 'bullseye') && Array.isArray(data.bullseye)) {

			data.bullseye.map(value => {
				this.bullseye.push(new SuperPartnerVO(value));
			})
		}

		if (_hasProperty(data, 'other') && Array.isArray(data.other)) {

			data.other.map(value2 => {
				this.other.push(new SuperPartnerVO(value2));
			})
		}

		if (_hasProperty(data, 'arrOtherAnswers') && (typeof data.arrOtherAnswers === 'object')) {
			this.arrOtherAnswers = data.arrOtherAnswers;
		}

		if (_hasProperty(data, 'withoutMatch')) {
			this.withoutMatch = data.withoutMatch;
		}
	}

}
